import { boolean, object, string } from "yup";

const EsimPartnerSchema = object().shape({
  companyName: string().required("Vendos emrin e kompanise"),
  allowedEmail: string()
    .email("Email adresa nuk eshte valide")
    .required("Vendos email-in qe do te kete qasje"),
  logoUrl: string()
    .url("URL e logos nuk eshte e vlefshme")
    .required("Vendos URL-ne e logos"),
  helpCenterUrl: string()
    .url("URL e Help Center nuk eshte e vlefshme")
    .nullable()
    .transform((value: string) => (value === "" ? null : value)),
  isActive: boolean()
});

export default EsimPartnerSchema;
